import { OmniaConfig } from "../../config";
import { HelpLink } from "../../shell";
import { IUibModalScope } from "../../types";
import { defineDirective } from "../../utils/angular";

/** @internal */
export function createHelpDialog(): ng.IDirective {

    return defineDirective(HelpDialogCtrl, "shared/main/help/help-dialog.html", {
        helpKey: "@"
    });

};

/** @internal */
export class HelpDialogCtrl {

    private $scope: IUibModalScope;
    private link: HelpLink;
    private youtube: boolean;

    static $inject = ["$scope", "$sce", "omniaConfig"];

    constructor($scope: ng.IScope, private $sce: ng.ISCEService, private config: OmniaConfig) {

        this.$scope = <IUibModalScope>$scope.$parent;

        if (this.$scope && this.$scope["link"]) {
            this.link = this.$scope["link"];
            this.youtube = this.link.link.indexOf('help') === -1;
        }
    }

    cancel() {
        this.$scope.$dismiss();
    }

    get appBrandName() {
        return this.config?.brand?.name
    }

    getLink() {
        return this.youtube ? this.getYoutubeLink() : this.link.link;
    }

    getYoutubeLink() {
        return this.$sce.trustAsResourceUrl("https://www.youtube.com/embed/" + this.link.link);
    }

    getHelpTitle(link: HelpLink) {
        return link.title.replace("(@brand)", this.appBrandName)
    }

}
